// extracted by mini-css-extract-plugin
export default {"select":"PeriodSelector_select__oaRRL","quarters":"PeriodSelector_quarters__1y78H"};